import { Box } from "@sembark-travel/ui-base"
import { Helmet } from "react-helmet-async"
import { useHasFeatureFlag } from "../../../Auth"
import { OnboardingChannelManager } from "../../../Integrations"
import { Navigate, useNavigate } from "../../../router-utils"

export default function OnboardingChannelManagerPage() {
	const navigate = useNavigate()
	const canIntegrateChannelManager = useHasFeatureFlag("cm_integration")
	if (!canIntegrateChannelManager) {
		return <Navigate to="/onboarding/invite-users" replace />
	}
	return (
		<>
			<Helmet>
				<title>Channel Manager | Onboarding</title>
			</Helmet>
			<Box
				maxWidth="4xl"
				marginX="auto"
				padding="8"
				borderWidth="1"
				rounded="md"
				bgColor="default"
				marginBottom="16"
			>
				<Box
					borderBottomWidth="1"
					display="inlineBlock"
					fontWeight="semibold"
					marginBottom="8"
					color="primary"
					fontSize="lg"
				>
					Onboarding &gt; Channel Manager
				</Box>
				<OnboardingChannelManager
					onSuccess={() => navigate("/onboarding/invite-users")}
					onSkip={() => navigate("/onboarding/invite-users")}
				/>
			</Box>
		</>
	)
}
